module.exports = __webpack_public_path__ + "img/index_pic3.0f4c03e7.png";